function textBoxResize(textBox) {
    textBox.each(function () {
        var textHeight = $(this).height();
        $(this).css('min-height', (textHeight) + 'px');
    });
}
jQuery('document').ready(function ($) {
    textBoxResize($('.text-content'));
    $(window).resize(function () {
        if ($(window).width() < 576) {
            $('.text-content').css('min-height', '40px');
        }
    });
});
